import { Link } from 'react-router-dom';
import { Recipes1 } from '../../assets/images';
import { useEffect } from 'react';
import { useFetch } from '../../utilities/hooks';
import { Preloader } from '../../components';
import './styles.css';

const RelatedNews = ({ categoryId, newsId }) => {
    /*const BASE_URL = process.env.REACT_APP_API_BASE_URL;*/

    

    const BASE_URL = process.env.REACT_APP_API_BASE_URL_NEWS;
    const { data } = useFetch(
        `${BASE_URL}/api/news/related/${newsId}/${categoryId}`
    );

    useEffect(() => {
        if (data) {
            /*console.log(data);*/
        }
    }, [data]);

    return (
        <div className='row'>
            {data?.news ? (
                data?.news.length == 0 ? (
                    <></>
                ) : (
                    <>
                            
                            <div className="col-xs-12">
                                <br/><br/>
                                <h4 className='alx-color-naranja alx-bold alx-titulo-related mb-4'>
                                    RELATED NEWS
                                </h4>
                            </div>
                        
                                
                        {data.news.map((noticia, i) => {
                            return (

                                <div className="col-xs-12 col-md-4" 
                                    key={noticia.id}
                                > 
                                    <Link to={'/news/' + noticia.slug} 
                                        onClick={() => window.scrollTo(0, 0)}
                                        className='alx-receta-min'>
                                        <img
                                             src={
                                                    BASE_URL +
                                                    '/uploads/noticias/' +
                                                    noticia.imagen_mobile
                                                }
                                            alt=""
                                            className='w-auto img-fluid'
                                        />
                                        <div class="alx-color-cafe">
                                            {noticia.titulo}
                                        </div>
                                    </Link>
                                </div>
                            );
                        })}
                    </>
                )
            ) : (
                <Preloader />
            )}
        </div>
    );
};

export default RelatedNews;
